import React, { useEffect, useState, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { Endpoints } from "../../repository/Endpoints";
import { GetMaker } from "../../repository/RequestMaker";
import { Translations } from "../../repository/Translations";
import { Spinner } from "react-bootstrap";
import { Language } from "./Language";
import Modal from "react-modal";
import PrivacyStatement from "../privacyStatement/PrivacyStatement";
import Swal from "sweetalert2";
import Select from 'react-select';

import "./Home.css"; // Import the updated CSS file

Modal.setAppElement("#root");
const Home = () => {
  const history = useHistory();
  const [languageAvailable, setLanguageAvailable] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [langToggled, setLangToggled] = useState(false);
  const [cookieChecked, setCookieChecked] = useState(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [inMaintainance, setInMaintainance] = useState(false);
  const [selectedLang, setSelectedLang] = useState(null);
  const [buttonText, setButtonText] = useState("");

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {}

  function closeModal() {
    setIsOpen(false);
  }

  const onNext = (e) => {
    // Save Static Tenant ID in the LS for Tennet 
    localStorage.setItem("tenant_id", "719e48fc-5548-4e2e-ba43-a011934b2c89");

    e.preventDefault();
    if (langToggled && cookieChecked) {
      // history.push({
      //   pathname: "/projects",
      // });
    const selectedProjectId = localStorage.getItem("selected_project_id")
    if (selectedProjectId) {
      history.push(`/trainings/${selectedProjectId}`);
    }
    }
    if (!langToggled) {
      Swal.fire({
        text: "Bitte wählen Sie die gewünschte Sprache // Please select the desired language",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
    }
    if (!cookieChecked) {
      Swal.fire({
        text: 'Bitte klicken Sie zum Fortfahren auf das Kontrollkästchen neben der Erklärung "Ich habe die Datenschutzhinweise & Nutzungsbedingungen gelesen ...".',
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
    }
  };

  const setLanguage = (option) => {
    setLangToggled(true);
    setSelectedLang(option);
    const { id, lang } = option.value;
    localStorage.setItem("language_id", id);
    localStorage.setItem("language", lang);

    Translations(lang, Language);
    const translatedButtonText = Language[lang]["button_next"] || "Weiter";
    setButtonText(translatedButtonText);
  };

  useEffect(() => {
    const selectedProjectId = localStorage.getItem("selected_project_id")
    const tenantId = localStorage.getItem("tenant_id");
    const endpoint = Endpoints.list_languages(tenantId, selectedProjectId);


    GetMaker(endpoint).then((res) => {
      console.log("res is ", res);
      console.log("tenantId is ", tenantId);
      console.log("selectedProjectId is ", selectedProjectId);

      const languageOptions = res.data.map((data) => ({
        value: { id: data.id, lang: data.lang },
        label: data.name,
      }));
      setLanguages(languageOptions);
      setLanguageAvailable(true);
    });
  }, []);

  useLayoutEffect(() => {
    if (!inMaintainance) Translations("de", Language);
  }, []);

  return inMaintainance ? (
    <h1>Website im Aufbau. In Kürze wieder verfügbar.</h1>
  ) : (
    <>
        <div className="bg-mine-home">
          <h1 className="text-title-color" id="title_text"></h1>
          <h1 className="text-title-color" id="title_text_2"></h1>
          <hr className="my-4 text-title-color title_underline" />

          <div className="dropdown-container">
            {languageAvailable ? (
              <Select
                options={languages}
                onChange={setLanguage}
                placeholder="Select Language / Sprache wählen"
                styles={{
                  option: (base, state) => ({
                    ...base,
                    color: state.isSelected ? '#073e87' : '#073e87', // Keep the text blue whether selected or not
                    backgroundColor: 'transparent', // Remove the background color for selected items
                    ':hover': {
                      backgroundColor: '#073e87', // Blue background on hover
                      color: 'white', // White text on hover
                    }
                  }),
                }}
              />
            ) : (
              <Spinner animation="grow" />
            )}
          </div>

          <br /> <br />

          {selectedLang && (
            <div className="button-container">
              <button
                className="styled-button"
                id="next_button"
                onClick={onNext}
              >
                {buttonText}
                &nbsp;
                <i className="fa fa-forward icon-border" aria-hidden="true"></i>
              </button>
            </div>
          )}

          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              borderRadius: 20,
            }}
          >
            <div className="d-flex justify-content-end">
              <button className="btn-smol" onClick={closeModal}>
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <PrivacyStatement />
          </Modal>
        </div>
    </>
  );
};

export default Home;
